import axios from "axios";
import { User } from "../models/user";
import { Aperture, AspectPergola, DimensionPergola, DimensionPergolaLoad, EmailRilievo, Fioriere, LatoIlluminazioneFaretto, MuroPergola, Pilastri, Rilievo, Tubolare, VetroType } from "../models/pergola_configuration";
import { GenericRequestResult } from "../core/common_types";
import { error, getAxiosConfig } from "../core/common_functions";
import { LatoIlluminazioneLed, LatoPergola } from "../routes/configurations/pergola/builder/components/pergola-draw/Pergola";
import { Accessorio, DoorConfigurationConditions, QuoteSummary } from "../models/door_configuration";
import { ClosuresApiResponse } from "../routes/configurations/pergola/builder/components/forms/Pergola_type";
export const usePergolaConfigurationsApi = () => {
    const area = "pergola-configurations";
    return {
        async putDimensions(currentUser: User, configurationId: number, model: DimensionPergola): Promise<GenericRequestResult<any>> {
            try {
                let response = await axios.put(`${process.env.REACT_APP_API_URL}/${area}/${configurationId}/dimensions-pergola`, model, getAxiosConfig(currentUser));
                return response.data;
            } catch (e: any) {
                throw error(e);
            }
        },
        async getQuote(currentUser: User, configurationId: number): Promise<GenericRequestResult<QuoteSummary>> {
            try {
                let response = await axios.get(`${process.env.REACT_APP_API_URL}/${area}/${configurationId}/quote`, getAxiosConfig(currentUser));

                return response.data;
            } catch (e: any) {
                throw error(e);
            }
        },
        async sendRilievo(currentUser: User, configurationId: number, data: EmailRilievo): Promise<GenericRequestResult<any>> {
            try {
                let response = await axios.post(`${process.env.REACT_APP_API_URL}/${area}/${configurationId}/submit-rilievo`, data, getAxiosConfig(currentUser));

                return response.data;
            } catch (e: any) {
                throw error(e);
            }
        },
        async setConditions(currentUser: User, configurationId: number, data: DoorConfigurationConditions): Promise<GenericRequestResult<DoorConfigurationConditions>> {
            try {
                let response = await axios.put(`${process.env.REACT_APP_API_URL}/${area}/${configurationId}/conditions`, data, getAxiosConfig(currentUser));

                return response.data;
            } catch (e: any) {
                throw error(e);
            }
        },
        async updateConditions(currentUser: User, configurationId: number, data: DoorConfigurationConditions): Promise<GenericRequestResult<DoorConfigurationConditions>> {
            try {
                let response = await axios.post(`${process.env.REACT_APP_API_URL}/${area}/${configurationId}/validate-conditions`, data, getAxiosConfig(currentUser));

                return response.data;
            } catch (e: any) {
                throw error(e);
            }
        },
        async build(currentUser: User, configurationId: number): Promise<any> {
            try {
                let response = await axios.get(`${process.env.REACT_APP_API_URL}/${area}/${configurationId}/build-quote`, getAxiosConfig(currentUser));

                return response.data;
            } catch (e: any) {
                throw error(e);
            }
        },
        async putForma(currentUser: User, configurationId: number, model: string): Promise<GenericRequestResult<any>> {
            try {
                const response = await axios.put(
                    `${process.env.REACT_APP_API_URL}/${area}/${configurationId}/forma-pergola`,
                    { forma: model }, // Wrap the string in a JSON object to match backend expectation
                    getAxiosConfig(currentUser)
                );
                return response.data;
            } catch (e: any) {
                throw new Error(e.message || 'Failed to update forma pergola');
            }
        },
        async putAspect(currentUser: User, configurationId: number, model: AspectPergola): Promise<GenericRequestResult<any>> {
            try {
                let response = await axios.put(`${process.env.REACT_APP_API_URL}/${area}/${configurationId}/aspect-pergola`, model, getAxiosConfig(currentUser));
                if (response.status != 200) {
                    throw response.statusText;
                }
                return response.data;
            } catch (e: any) {
                throw error(e);
            }
        },
        async putImagePdf(currentUser: User, configurationId: number, model: FormData): Promise<GenericRequestResult<any>> {
            try {
                let response = await axios.post(
                    `${process.env.REACT_APP_API_URL}/${area}/${configurationId}/upload-image`,
                    model,
                    getAxiosConfig(currentUser)
                );
                if (response.status != 200) {
                    throw response.statusText;
                }
                return response.data;
            } catch (e: any) {
                throw error(e);
            }
        },
        async putImageDetail(currentUser: User, configurationId: number, model: FormData): Promise<GenericRequestResult<any>> {
            try {
                let response = await axios.post(
                    `${process.env.REACT_APP_API_URL}/${area}/${configurationId}/upload-detail`,
                    model,
                    getAxiosConfig(currentUser)
                );
                if (response.status != 200) {
                    throw response.statusText;
                }
                return response.data;
            } catch (e: any) {
                throw error(e);
            }
        },
        async findGenericAccessoriesPergola(currentUser: User, configurationId: number): Promise<GenericRequestResult<Accessorio[]>> {
            try {
                let response = await axios.get(`${process.env.REACT_APP_API_URL}/${area}/${configurationId}/generic-accessories/findPergola`, getAxiosConfig(currentUser));

                return response.data;
            } catch (e: any) {
                throw error(e);
            }
        },
        async get(currentUser: User, configurationId: number): Promise<GenericRequestResult<DimensionPergolaLoad>> {
            try {
                let response = await axios.get(`${process.env.REACT_APP_API_URL}/${area}/${configurationId}`, getAxiosConfig(currentUser));

                return response.data;
            } catch (e: any) {
                throw error(e);
            }
        },
        async putChiusure(currentUser: User, configurationId: number, model: {chiusure: LatoPergola[]}): Promise<GenericRequestResult<any>> {
            try {
                let response = await axios.put(`${process.env.REACT_APP_API_URL}/${area}/${configurationId}/closures-pergola`, model, getAxiosConfig(currentUser));
                if (response.status != 200) {
                    throw response.statusText;
                }
                return response.data;
            } catch (e: any) {
                throw error(e);
            }
        },
        async putFioriere(currentUser: User, configurationId: number, model: {fioriere: Fioriere[]}): Promise<GenericRequestResult<any>> {
            try {
                let response = await axios.put(`${process.env.REACT_APP_API_URL}/${area}/${configurationId}/fioriere`, model, getAxiosConfig(currentUser));
                if (response.status != 200) {
                    throw response.statusText;
                }
                return response.data;
            } catch (e: any) {
                throw error(e);
            }
        },
        async putTubolari(currentUser: User, configurationId: number, model: {tubolari: Tubolare[]}): Promise<GenericRequestResult<any>> {
            try {
                let response = await axios.put(`${process.env.REACT_APP_API_URL}/${area}/${configurationId}/tubolari-pergola`, model, getAxiosConfig(currentUser));
                if (response.status != 200) {
                    throw response.statusText;
                }
                return response.data;
            } catch (e: any) {
                throw error(e);
            }
        },
        async getVieMaia(currentUser: User, configurationId: number, model: {width: number,heigth: number,tipo_vetro: VetroType,apertura: Aperture}): Promise<GenericRequestResult<any>> {
            try {
                let response = await axios.post(`${process.env.REACT_APP_API_URL}/${area}/${configurationId}/vie`, model, getAxiosConfig(currentUser));
                if (response.status != 200) {
                    throw response.statusText;
                }
                return response.data;
            } catch (e: any) {
                throw error(e);
            }
        },
        async putIlluminazione(currentUser: User, configurationId: number, model: {ledAttive: LatoIlluminazioneLed[], faretti: LatoIlluminazioneFaretto}): Promise<GenericRequestResult<any>> {
            try {
                let response = await axios.put(`${process.env.REACT_APP_API_URL}/${area}/${configurationId}/lighting-pergola`, model, getAxiosConfig(currentUser));
                if (response.status != 200) {
                    throw response.statusText;
                }
                return response.data;
            } catch (e: any) {
                throw error(e);
            }
        },
        async putPilastri(currentUser: User, configurationId: number, model: {pilastri: Pilastri[]}): Promise<GenericRequestResult<any>> {
            try {
                let response = await axios.put(`${process.env.REACT_APP_API_URL}/${area}/${configurationId}/pilastro`, model, getAxiosConfig(currentUser));
                if (response.status != 200) {
                    throw response.statusText;
                }
                return response.data;
            } catch (e: any) {
                throw error(e);
            }
        },
        async putMuri(currentUser: User, configurationId: number, model: {muri: MuroPergola[]}): Promise<GenericRequestResult<any>> {
            try {
                let response = await axios.put(`${process.env.REACT_APP_API_URL}/${area}/${configurationId}/muri`, model, getAxiosConfig(currentUser));
                if (response.status != 200) {
                    throw response.statusText;
                }
                return response.data;
            } catch (e: any) {
                throw error(e);
            }
        },
        async getChiusure(currentUser: User, configurationId: number): Promise<GenericRequestResult<LatoPergola[]>> {
            try {
                let response = await axios.get(`${process.env.REACT_APP_API_URL}/${area}/${configurationId}/closures`, getAxiosConfig(currentUser));

                return response.data;
            } catch (e: any) {
                throw error(e);
            }
        },
        async getClosuresAcc(currentUser: User, configurationId: number): Promise<ClosuresApiResponse> {
            try {
                let response = await axios.get(`${process.env.REACT_APP_API_URL}/${area}/${configurationId}/getClosuresAcc`, getAxiosConfig(currentUser));

                return response.data;
            } catch (e: any) {
                throw error(e);
            }
        },
        async getMuri(currentUser: User, configurationId: number): Promise<GenericRequestResult<MuroPergola[]>> {
            try {
                let response = await axios.get(`${process.env.REACT_APP_API_URL}/${area}/${configurationId}/get-muri`, getAxiosConfig(currentUser));

                return response.data;
            } catch (e: any) {
                throw error(e);
            }
        },
        async getPilastri(currentUser: User, configurationId: number): Promise<GenericRequestResult<Pilastri[]>> {
            try {
                let response = await axios.get(`${process.env.REACT_APP_API_URL}/${area}/${configurationId}/get-pilastri`, getAxiosConfig(currentUser));

                return response.data;
            } catch (e: any) {
                throw error(e);
            }
        },
        async getTubolari(currentUser: User, configurationId: number): Promise<GenericRequestResult<Tubolare[]>> {
            try {
                let response = await axios.get(`${process.env.REACT_APP_API_URL}/${area}/${configurationId}/tubolari`, getAxiosConfig(currentUser));

                return response.data;
            } catch (e: any) {
                throw error(e);
            }
        },
        async getRilievo(currentUser: User, configurationId: number): Promise<GenericRequestResult<Rilievo>> {
            try {
                let response = await axios.get(`${process.env.REACT_APP_API_URL}/${area}/${configurationId}/get-rilievo`, getAxiosConfig(currentUser));

                return response.data;
            } catch (e: any) {
                throw error(e);
            }
        },
async getNeedTrave(
  currentUser: User,
  configurationId: number,
  larghezzaSoletta: number,
  lunghezzaSoletta: number
): Promise<GenericRequestResult<boolean>> {
  try {
    const response = await axios.post(
      `${process.env.REACT_APP_API_URL}/${area}/${configurationId}/trave`,
      {
        width: larghezzaSoletta,
        prof: lunghezzaSoletta,
      },
      getAxiosConfig(currentUser)
    );

    return response.data;
  } catch (e: any) {
    throw error(e);
  }
},
        async getIlluminazioni(currentUser: User, configurationId: number): Promise<GenericRequestResult<LatoIlluminazioneLed[]>> {
            try {
                let response = await axios.get(`${process.env.REACT_APP_API_URL}/${area}/${configurationId}/lights`, getAxiosConfig(currentUser));

                return response.data;
            } catch (e: any) {
                throw error(e);
            }
        },
        async getFioriere(currentUser: User, configurationId: number): Promise<GenericRequestResult<Fioriere[]>> {
            try {
                let response = await axios.get(`${process.env.REACT_APP_API_URL}/${area}/${configurationId}/get-fioriere`, getAxiosConfig(currentUser));

                return response.data;
            } catch (e: any) {
                throw error(e);
            }
        },
        async getForma(currentUser: User, configurationId: number): Promise<GenericRequestResult<string>> {
            try {
                let response = await axios.get(`${process.env.REACT_APP_API_URL}/${area}/${configurationId}/forma`, getAxiosConfig(currentUser));

                return response.data;
            } catch (e: any) {
                throw error(e);
            }
        },
    }
}